/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Submitting_Application_LoadingInputs */

const en_submitting_application_loading = /** @type {(inputs: Submitting_Application_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Submitting application…`)
};

const de_submitting_application_loading = /** @type {(inputs: Submitting_Application_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bewerbung wird eingereicht…`)
};

/**
* | output |
* | --- |
* | "Submitting application…" |
*
* @param {Submitting_Application_LoadingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const submitting_application_loading = /** @type {((inputs?: Submitting_Application_LoadingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Submitting_Application_LoadingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_submitting_application_loading(inputs)
	return en_submitting_application_loading(inputs)
});